var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Given a list of roles definitions, a list of user roles and a list of user permissions, returns the user permissions.
 */
export var getPermissionsFromRoles = function (_a) {
    var roleDefinitions = _a.roleDefinitions, _b = _a.userPermissions, userPermissions = _b === void 0 ? [] : _b, _c = _a.userRoles, userRoles = _c === void 0 ? [] : _c;
    return userRoles.reduce(function (acc, role) { var _a; return acc.concat((_a = roleDefinitions[role]) !== null && _a !== void 0 ? _a : []); }, __spreadArray([], userPermissions, true));
};
